import { z } from 'zod';
import { ClaimEventSchema, ClaimEventType, claimEventType } from './claim.js';
import { BaseClaimSchema } from '../model/base.js';
export const ClaimCreatedEventSchema = ClaimEventSchema.merge(z.object({
    type: claimEventType(ClaimEventType.claimCreated),
    claim: BaseClaimSchema,
}));
